import React from 'react';
import PropTypes from 'prop-types';

function AddressHiddenFields({ address }) {
  return (
    <>
      <input type="hidden" data-testid="addresses.homeDelivery.sameDayStoreId" value={address.sameDayStoreId || ''} name="addresses.homeDelivery.sameDayStoreId" />
      <input type="hidden" value={address.address1 || ''} name="addresses.homeDelivery.address1" data-testid="addresses.homeDelivery.address1" />
      <input type="hidden" value={address.address2 || ''} name="addresses.homeDelivery.address2" data-testid="addresses.homeDelivery.address2" />
      <input type="hidden" value={address.addressId || ''} name="addresses.homeDelivery.addressId" data-testid="addresses.homeDelivery.addressId" />
      <input type="hidden" value={address.city || ''} name="addresses.homeDelivery.city" data-testid="addresses.homeDelivery.city" />
      <input type="hidden" value={address.state || ''} name="addresses.homeDelivery.country" data-testid="addresses.homeDelivery.country" />
      <input type="hidden" value={address.isAddressVerified || ''} name="addresses.homeDelivery.isAddressVerified" data-testid="addresses.homeDelivery.isAddressVerified" />
      <input type="hidden" value={address.email || ''} name="addresses.homeDelivery.email" data-testid="addresses.homeDelivery.email" />
      <input type="hidden" value={address.isBillingAllowed || ''} name="addresses.homeDelivery.isBillingAllowed" data-testid="addresses.homeDelivery.isBillingAllowed" />
      <input type="hidden" value={address.isDefaultBilling || ''} name="addresses.homeDelivery.isDefaultBilling" data-testid="addresses.homeDelivery.isDefaultBilling" />
      <input type="hidden" value={address.isDefaultShipping || ''} name="addresses.homeDelivery.isDefaultShipping" data-testid="addresses.homeDelivery.isDefaultShipping" />
      <input type="hidden" value={address.isShippingAllowed || ''} name="addresses.homeDelivery.isShippingAllowed" data-testid="addresses.homeDelivery.isShippingAllowed" />
      <input type="hidden" value={address.firstName || ''} name="addresses.homeDelivery.firstName" data-testid="addresses.homeDelivery.firstName" />
      <input type="hidden" value={address.lastName || ''} name="addresses.homeDelivery.lastName" data-testid="addresses.homeDelivery.lastName" />
      <input type="hidden" value={address.orgName || ''} name="addresses.homeDelivery.orgName" data-testid="addresses.homeDelivery.orgName" />
      <input type="hidden" value={address.pickUpStoreId || ''} name="addresses.homeDelivery.pickUpStoreId" data-testid="addresses.homeDelivery.pickUpStoreId" />
      <input type="hidden" value={address.poBox || ''} name="addresses.homeDelivery.poBox" data-testid="addresses.homeDelivery.poBox" />
      <input type="hidden" value={address.postalCode || ''} name="addresses.homeDelivery.postalCode" data-testid="addresses.homeDelivery.postalCode" />
      <input type="hidden" value={address.state || ''} name="addresses.homeDelivery.state" data-testid="addresses.homeDelivery.state" />
      <input type="hidden" value={address.title || ''} name="addresses.homeDelivery.title" data-testid="addresses.homeDelivery.title" />
      <input type="hidden" value={address.zone || ''} name="addresses.homeDelivery.zone" data-testid="addresses.homeDelivery.zone" />
      <input type="hidden" value={address.district || ''} name="addresses.homeDelivery.district" data-testid="addresses.homeDelivery.district" />
      <input type="hidden" value={address.prefecture || ''} name="addresses.homeDelivery.prefecture" data-testid="addresses.homeDelivery.prefecture" />
    </>
  );
}

AddressHiddenFields.propTypes = {
  address: PropTypes.shape({
    sameDayStoreId: PropTypes.string,
    address1: PropTypes.string,
    address2: PropTypes.string,
    addressId: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    isAddressVerified: PropTypes.bool,
    email: PropTypes.string,
    isBillingAllowed: PropTypes.bool,
    isDefaultBilling: PropTypes.bool,
    isDefaultShipping: PropTypes.bool,
    isShippingAllowed: PropTypes.bool,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    orgName: PropTypes.string,
    pickUpStoreId: PropTypes.string,
    poBox: PropTypes.bool,
    postalCode: PropTypes.string,
    state: PropTypes.string,
    title: PropTypes.string,
    zone: PropTypes.string,
    district: PropTypes.string,
    prefecture: PropTypes.string,
  }),
};

AddressHiddenFields.defaultProps = {
  address: {
    sameDayStoreId: '',
    address1: '',
    address2: '',
    addressId: '',
    city: '',
    country: '',
    isAddressVerified: false,
    email: '',
    isBillingAllowed: false,
    isDefaultBilling: false,
    isDefaultShipping: false,
    isShippingAllowed: false,
    firstName: '',
    lastName: '',
    orgName: '',
    pickUpStoreId: '',
    poBox: false,
    postalCode: '',
    state: '',
    title: '',
    zone: '',
    district: '',
    prefecture: '',
  },
};
export default AddressHiddenFields;
